import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CorrelationModule } from '@wdpr/ra-angular-correlation';

import { FinderButtonModule } from '@finder/shared/components/finder-button/finder-button.module';
import { JsonEditorModule } from '../json-editor/json-editor.module';
import { DebugPanelComponent } from './debug-panel.component';
import { SquirtModule } from '@finder/shared/features/squirt/squirt.module';

@NgModule({
    imports: [
        CommonModule,
        JsonEditorModule,
        CorrelationModule,
        FinderButtonModule,
        SquirtModule,
    ],
    declarations: [
        DebugPanelComponent
    ],
    providers: [],
    exports: [
        DebugPanelComponent
    ]
})
export class DebugPanelModule {
    static entry = DebugPanelComponent;
}
